// extracted by mini-css-extract-plugin
export default {"card":"AnalyticsDashboard_card__tyrkz"};